export const timezoneMap: Record<'amer' | 'emea' | 'apjc', string[]> = {
  amer: [
    "America/Adak (-9 hr)",
    "America/Anchorage (-8 hr)",
    "America/Anguilla (-4 hr)",
    "America/Antigua (-4 hr)",
    "America/Araguaina (-3 hr)",
    "America/Argentina/Buenos_Aires (-3 hr)",
    "America/Argentina/Catamarca (-3 hr)",
    "America/Argentina/Cordoba (-3 hr)",
    "America/Argentina/Jujuy (-3 hr)",
    "America/Argentina/La_Rioja (-3 hr)",
    "America/Argentina/Mendoza (-3 hr)",
    "America/Argentina/Rio_Gallegos (-3 hr)",
    "America/Argentina/Salta (-3 hr)",
    "America/Argentina/San_Juan (-3 hr)",
    "America/Argentina/San_Luis (-3 hr)",
    "America/Argentina/Tucuman (-3 hr)",
    "America/Argentina/Ushuaia (-3 hr)",
    "America/Aruba (-4 hr)",
    "America/Asuncion (-3 hr)",
    "America/Atikokan (-5 hr)",
    "America/Bahia (-3 hr)",
    "America/Bahia_Banderas (-6 hr)",
    "America/Barbados (-4 hr)",
    "America/Belem (-3 hr)",
    "America/Belize (-6 hr)",
    "America/Blanc-Sablon (-4 hr)",
    "America/Boa_Vista (-4 hr)",
    "America/Bogota (-5 hr)",
    "America/Boise (-6 hr)",
    "America/Cambridge_Bay (-6 hr)",
    "America/Campo_Grande (-4 hr)",
    "America/Cancun (-5 hr)",
    "America/Caracas (-4 hr)",
    "America/Cayenne (-3 hr)",
    "America/Cayman (-5 hr)",
    "America/Chicago (-5 hr)",
    "America/Chihuahua (-6 hr)",
    "America/Ciudad_Juarez (-6 hr)",
    "America/Costa_Rica (-6 hr)",
    "America/Creston (-7 hr)",
    "America/Cuiaba (-4 hr)",
    "America/Curacao (-4 hr)",
    "America/Danmarkshavn (0 hr)",
    "America/Dawson (-7 hr)",
    "America/Dawson_Creek (-7 hr)",
    "America/Denver (-6 hr)",
    "America/Detroit (-4 hr)",
    "America/Dominica (-4 hr)",
    "America/Edmonton (-6 hr)",
    "America/Eirunepe (-5 hr)",
    "America/El_Salvador (-6 hr)",
    "America/Fort_Nelson (-7 hr)",
    "America/Fortaleza (-3 hr)",
    "America/Glace_Bay (-3 hr)",
    "America/Goose_Bay (-3 hr)",
    "America/Grand_Turk (-4 hr)",
    "America/Grenada (-4 hr)",
    "America/Guadeloupe (-4 hr)",
    "America/Guatemala (-6 hr)",
    "America/Guayaquil (-5 hr)",
    "America/Guyana (-4 hr)",
    "America/Halifax (-3 hr)",
    "America/Havana (-4 hr)",
    "America/Hermosillo (-7 hr)",
    "America/Indiana/Indianapolis (-4 hr)",
    "America/Indiana/Knox (-5 hr)",
    "America/Indiana/Marengo (-4 hr)",
    "America/Indiana/Petersburg (-4 hr)",
    "America/Indiana/Tell_City (-5 hr)",
    "America/Indiana/Vevay (-4 hr)",
    "America/Indiana/Vincennes (-4 hr)",
    "America/Indiana/Winamac (-4 hr)",
    "America/Inuvik (-6 hr)",
    "America/Iqaluit (-4 hr)",
    "America/Jamaica (-5 hr)",
    "America/Juneau (-8 hr)",
    "America/Kentucky/Louisville (-4 hr)",
    "America/Kentucky/Monticello (-4 hr)",
    "America/Kralendijk (-4 hr)",
    "America/La_Paz (-4 hr)",
    "America/Lima (-5 hr)",
    "America/Los_Angeles (-7 hr)",
    "America/Lower_Princes (-4 hr)",
    "America/Maceio (-3 hr)",
    "America/Managua (-6 hr)",
    "America/Manaus (-4 hr)",
    "America/Marigot (-4 hr)",
    "America/Martinique (-4 hr)",
    "America/Matamoros (-5 hr)",
    "America/Mazatlan (-7 hr)",
    "America/Menominee (-5 hr)",
    "America/Merida (-6 hr)",
    "America/Metlakatla (-8 hr)",
    "America/Mexico_City (-6 hr)",
    "America/Miquelon (-2 hr)",
    "America/Moncton (-3 hr)",
    "America/Monterrey (-6 hr)",
    "America/Montevideo (-3 hr)",
    "America/Montserrat (-4 hr)",
    "America/Nassau (-4 hr)",
    "America/New_York (-4 hr)",
    "America/Nome (-8 hr)",
    "America/Noronha (-2 hr)",
    "America/North_Dakota/Beulah (-5 hr)",
    "America/North_Dakota/Center (-5 hr)",
    "America/North_Dakota/New_Salem (-5 hr)",
    "America/Nuuk (-1 hr)",
    "America/Ojinaga (-5 hr)",
    "America/Panama (-5 hr)",
    "America/Paramaribo (-3 hr)",
    "America/Phoenix (-7 hr)",
    "America/Port-au-Prince (-4 hr)",
    "America/Port_of_Spain (-4 hr)",
    "America/Porto_Velho (-4 hr)",
    "America/Puerto_Rico (-4 hr)",
    "America/Punta_Arenas (-3 hr)",
    "America/Rankin_Inlet (-5 hr)",
    "America/Recife (-3 hr)",
    "America/Regina (-6 hr)",
    "America/Resolute (-5 hr)",
    "America/Rio_Branco (-5 hr)",
    "America/Santarem (-3 hr)",
    "America/Santiago (-3 hr)",
    "America/Santo_Domingo (-4 hr)",
    "America/Sao_Paulo (-3 hr)",
    "America/Scoresbysund (-1 hr)",
    "America/Sitka (-8 hr)",
    "America/St_Barthelemy (-4 hr)",
    "America/St_Johns (-2.5 hr)",
    "America/St_Kitts (-4 hr)",
    "America/St_Lucia (-4 hr)",
    "America/St_Thomas (-4 hr)",
    "America/St_Vincent (-4 hr)",
    "America/Swift_Current (-6 hr)",
    "America/Tegucigalpa (-6 hr)",
    "America/Thule (-3 hr)",
    "America/Tijuana (-7 hr)",
    "America/Toronto (-4 hr)",
    "America/Tortola (-4 hr)",
    "America/Vancouver (-7 hr)",
    "America/Whitehorse (-7 hr)",
    "America/Winnipeg (-5 hr)",
    "America/Yakutat (-8 hr)",
    "Pacific/Easter (-5 hr)",
    "Pacific/Galapagos (-6 hr)",
    "Pacific/Gambier (-9 hr)",
    "Pacific/Honolulu (-10 hr)",
    "Pacific/Marquesas (-9.5 hr)",
    "Pacific/Midway (-11 hr)",
    "Pacific/Pago_Pago (-11 hr)",
    "Pacific/Pitcairn (-8 hr)",
    "Pacific/Rarotonga (-10 hr)",
    "Pacific/Tahiti (-10 hr)",
    "UTC (0 hr)"
  ],
  emea: [
    "Africa/Abidjan (0 hr)",
    "Africa/Accra (0 hr)",
    "Africa/Addis_Ababa (3 hr)",
    "Africa/Algiers (1 hr)",
    "Africa/Asmara (3 hr)",
    "Africa/Bamako (0 hr)",
    "Africa/Bangui (1 hr)",
    "Africa/Banjul (0 hr)",
    "Africa/Bissau (0 hr)",
    "Africa/Blantyre (2 hr)",
    "Africa/Brazzaville (1 hr)",
    "Africa/Bujumbura (2 hr)",
    "Africa/Cairo (3 hr)",
    "Africa/Casablanca (1 hr)",
    "Africa/Ceuta (2 hr)",
    "Africa/Conakry (0 hr)",
    "Africa/Dakar (0 hr)",
    "Africa/Dar_es_Salaam (3 hr)",
    "Africa/Djibouti (3 hr)",
    "Africa/Douala (1 hr)",
    "Africa/El_Aaiun (1 hr)",
    "Africa/Freetown (0 hr)",
    "Africa/Gaborone (2 hr)",
    "Africa/Harare (2 hr)",
    "Africa/Johannesburg (2 hr)",
    "Africa/Juba (2 hr)",
    "Africa/Kampala (3 hr)",
    "Africa/Khartoum (2 hr)",
    "Africa/Kigali (2 hr)",
    "Africa/Kinshasa (1 hr)",
    "Africa/Lagos (1 hr)",
    "Africa/Libreville (1 hr)",
    "Africa/Lome (0 hr)",
    "Africa/Luanda (1 hr)",
    "Africa/Lubumbashi (2 hr)",
    "Africa/Lusaka (2 hr)",
    "Africa/Malabo (1 hr)",
    "Africa/Maputo (2 hr)",
    "Africa/Maseru (2 hr)",
    "Africa/Mbabane (2 hr)",
    "Africa/Mogadishu (3 hr)",
    "Africa/Monrovia (0 hr)",
    "Africa/Nairobi (3 hr)",
    "Africa/Ndjamena (1 hr)",
    "Africa/Niamey (1 hr)",
    "Africa/Nouakchott (0 hr)",
    "Africa/Ouagadougou (0 hr)",
    "Africa/Porto-Novo (1 hr)",
    "Africa/Sao_Tome (0 hr)",
    "Africa/Tripoli (2 hr)",
    "Africa/Tunis (1 hr)",
    "Africa/Windhoek (2 hr)",
    "Atlantic/Azores (0 hr)",
    "Atlantic/Canary (1 hr)",
    "Atlantic/Cape_Verde (-1 hr)",
    "Atlantic/Faroe (1 hr)",
    "Atlantic/Madeira (1 hr)",
    "Atlantic/Reykjavik (0 hr)",
    "Atlantic/South_Georgia (-2 hr)",
    "Atlantic/St_Helena (0 hr)",
    "Atlantic/Stanley (-3 hr)",
    "Europe/Amsterdam (2 hr)",
    "Europe/Andorra (2 hr)",
    "Europe/Astrakhan (4 hr)",
    "Europe/Athens (3 hr)",
    "Europe/Belgrade (2 hr)",
    "Europe/Berlin (2 hr)",
    "Europe/Bratislava (2 hr)",
    "Europe/Brussels (2 hr)",
    "Europe/Bucharest (3 hr)",
    "Europe/Budapest (2 hr)",
    "Europe/Busingen (2 hr)",
    "Europe/Chisinau (3 hr)",
    "Europe/Copenhagen (2 hr)",
    "Europe/Dublin (1 hr)",
    "Europe/Gibraltar (2 hr)",
    "Europe/Guernsey (1 hr)",
    "Europe/Helsinki (3 hr)",
    "Europe/Isle_of_Man (1 hr)",
    "Europe/Istanbul (3 hr)",
    "Europe/Jersey (1 hr)",
    "Europe/Kaliningrad (2 hr)",
    "Europe/Kirov (3 hr)",
    "Europe/Kyiv (3 hr)",
    "Europe/Lisbon (1 hr)",
    "Europe/Ljubljana (2 hr)",
    "Europe/London (1 hr)",
    "Europe/Luxembourg (2 hr)",
    "Europe/Madrid (2 hr)",
    "Europe/Malta (2 hr)",
    "Europe/Mariehamn (3 hr)",
    "Europe/Minsk (3 hr)",
    "Europe/Monaco (2 hr)",
    "Europe/Moscow (3 hr)",
    "Europe/Oslo (2 hr)",
    "Europe/Paris (2 hr)",
    "Europe/Podgorica (2 hr)",
    "Europe/Prague (2 hr)",
    "Europe/Riga (3 hr)",
    "Europe/Rome (2 hr)",
    "Europe/Samara (4 hr)",
    "Europe/San_Marino (2 hr)",
    "Europe/Sarajevo (2 hr)",
    "Europe/Saratov (4 hr)",
    "Europe/Simferopol (3 hr)",
    "Europe/Skopje (2 hr)",
    "Europe/Sofia (3 hr)",
    "Europe/Stockholm (2 hr)",
    "Europe/Tallinn (3 hr)",
    "Europe/Tirane (2 hr)",
    "Europe/Ulyanovsk (4 hr)",
    "Europe/Vaduz (2 hr)",
    "Europe/Vatican (2 hr)",
    "Europe/Vienna (2 hr)",
    "Europe/Vilnius (3 hr)",
    "Europe/Volgograd (3 hr)",
    "Europe/Warsaw (2 hr)",
    "Europe/Zagreb (2 hr)",
    "Europe/Zurich (2 hr)",
    "Indian/Antananarivo (3 hr)",
    "Indian/Chagos (6 hr)",
    "Indian/Christmas (7 hr)",
    "Indian/Cocos (6.5 hr)",
    "Indian/Comoro (3 hr)",
    "Indian/Kerguelen (5 hr)",
    "Indian/Mahe (4 hr)",
    "Indian/Maldives (5 hr)",
    "Indian/Mauritius (4 hr)",
    "Indian/Mayotte (3 hr)",
    "Indian/Reunion (4 hr)"
  ],
  apjc: [
    "Antarctica/Casey (8 hr)",
    "Antarctica/Davis (7 hr)",
    "Antarctica/DumontDUrville (10 hr)",
    "Antarctica/Macquarie (11 hr)",
    "Antarctica/Mawson (5 hr)",
    "Antarctica/McMurdo (13 hr)",
    "Antarctica/Palmer (-3 hr)",
    "Antarctica/Rothera (-3 hr)",
    "Antarctica/Syowa (3 hr)",
    "Antarctica/Troll (2 hr)",
    "Antarctica/Vostok (5 hr)",
    "Arctic/Longyearbyen (2 hr)",
    "Asia/Aden (3 hr)",
    "Asia/Almaty (5 hr)",
    "Asia/Amman (3 hr)",
    "Asia/Anadyr (12 hr)",
    "Asia/Aqtau (5 hr)",
    "Asia/Aqtobe (5 hr)",
    "Asia/Ashgabat (5 hr)",
    "Asia/Atyrau (5 hr)",
    "Asia/Baghdad (3 hr)",
    "Asia/Bahrain (3 hr)",
    "Asia/Baku (4 hr)",
    "Asia/Bangkok (7 hr)",
    "Asia/Barnaul (7 hr)",
    "Asia/Beirut (3 hr)",
    "Asia/Bishkek (6 hr)",
    "Asia/Brunei (8 hr)",
    "Asia/Chita (9 hr)",
    "Asia/Colombo (5.5 hr)",
    "Asia/Damascus (3 hr)",
    "Asia/Dhaka (6 hr)",
    "Asia/Dili (9 hr)",
    "Asia/Dubai (4 hr)",
    "Asia/Dushanbe (5 hr)",
    "Asia/Famagusta (3 hr)",
    "Asia/Gaza (3 hr)",
    "Asia/Hebron (3 hr)",
    "Asia/Ho_Chi_Minh (7 hr)",
    "Asia/Hong_Kong (8 hr)",
    "Asia/Hovd (7 hr)",
    "Asia/Irkutsk (8 hr)",
    "Asia/Jakarta (7 hr)",
    "Asia/Jayapura (9 hr)",
    "Asia/Jerusalem (3 hr)",
    "Asia/Kabul (4.5 hr)",
    "Asia/Kamchatka (12 hr)",
    "Asia/Karachi (5 hr)",
    "Asia/Kathmandu (5.75 hr)",
    "Asia/Khandyga (9 hr)",
    "Asia/Kolkata (5.5 hr)",
    "Asia/Krasnoyarsk (7 hr)",
    "Asia/Kuala_Lumpur (8 hr)",
    "Asia/Kuching (8 hr)",
    "Asia/Kuwait (3 hr)",
    "Asia/Macau (8 hr)",
    "Asia/Magadan (11 hr)",
    "Asia/Makassar (8 hr)",
    "Asia/Manila (8 hr)",
    "Asia/Muscat (4 hr)",
    "Asia/Nicosia (3 hr)",
    "Asia/Novokuznetsk (7 hr)",
    "Asia/Novosibirsk (7 hr)",
    "Asia/Omsk (6 hr)",
    "Asia/Oral (5 hr)",
    "Asia/Phnom_Penh (7 hr)",
    "Asia/Pontianak (7 hr)",
    "Asia/Pyongyang (9 hr)",
    "Asia/Qatar (3 hr)",
    "Asia/Qostanay (5 hr)",
    "Asia/Qyzylorda (5 hr)",
    "Asia/Riyadh (3 hr)",
    "Asia/Sakhalin (11 hr)",
    "Asia/Samarkand (5 hr)",
    "Asia/Seoul (9 hr)",
    "Asia/Shanghai (8 hr)",
    "Asia/Singapore (8 hr)",
    "Asia/Srednekolymsk (11 hr)",
    "Asia/Taipei (8 hr)",
    "Asia/Tashkent (5 hr)",
    "Asia/Tbilisi (4 hr)",
    "Asia/Tehran (3.5 hr)",
    "Asia/Thimphu (6 hr)",
    "Asia/Tokyo (9 hr)",
    "Asia/Tomsk (7 hr)",
    "Asia/Ulaanbaatar (8 hr)",
    "Asia/Urumqi (6 hr)",
    "Asia/Ust-Nera (10 hr)",
    "Asia/Vientiane (7 hr)",
    "Asia/Vladivostok (10 hr)",
    "Asia/Yakutsk (9 hr)",
    "Asia/Yangon (6.5 hr)",
    "Asia/Yekaterinburg (5 hr)",
    "Asia/Yerevan (4 hr)",
    "Australia/Adelaide (10.5 hr)",
    "Australia/Brisbane (10 hr)",
    "Australia/Broken_Hill (10.5 hr)",
    "Australia/Darwin (9.5 hr)",
    "Australia/Eucla (8.75 hr)",
    "Australia/Hobart (11 hr)",
    "Australia/Lindeman (10 hr)",
    "Australia/Lord_Howe (11 hr)",
    "Australia/Melbourne (11 hr)",
    "Australia/Perth (8 hr)",
    "Australia/Sydney (11 hr)",
    "Pacific/Apia (13 hr)",
    "Pacific/Auckland (13 hr)",
    "Pacific/Bougainville (11 hr)",
    "Pacific/Chatham (13.75 hr)",
    "Pacific/Chuuk (10 hr)",
    "Pacific/Efate (11 hr)",
    "Pacific/Fakaofo (13 hr)",
    "Pacific/Fiji (12 hr)",
    "Pacific/Funafuti (12 hr)",
    "Pacific/Guadalcanal (11 hr)",
    "Pacific/Guam (10 hr)",
    "Pacific/Kanton (13 hr)",
    "Pacific/Kiritimati (14 hr)",
    "Pacific/Kosrae (11 hr)",
    "Pacific/Kwajalein (12 hr)",
    "Pacific/Majuro (12 hr)",
    "Pacific/Nauru (12 hr)",
    "Pacific/Niue (-11 hr)",
    "Pacific/Norfolk (12 hr)",
    "Pacific/Noumea (11 hr)",
    "Pacific/Palau (9 hr)",
    "Pacific/Pohnpei (11 hr)",
    "Pacific/Port_Moresby (10 hr)",
    "Pacific/Saipan (10 hr)",
    "Pacific/Tarawa (12 hr)",
    "Pacific/Tongatapu (13 hr)",
    "Pacific/Wake (12 hr)",
    "Pacific/Wallis (12 hr)"
  ]
};